import { FloatingFormItem, InputDecimal } from '@/components/_common';
import { useDefaultEmptyFieldError } from '@/hooks';
import { Row, Col, Input, InputNumber, Typography } from 'antd';

interface Props {
  index: number;
}

const InvoiceCFEGeneralForm: React.FC<Props> = ({ index }) => {
  const ruleRequired = useDefaultEmptyFieldError();

  return (
    <Row style={{ marginBottom: 24 }} gutter={[16, 6]}>
      <Col span={12} md={6}>
        <FloatingFormItem
          parentFieldName="items"
          name={[index, 'unitMeasure']}
          label="Unidade de medida"
          rules={[ruleRequired]}
        >
          <Input />
        </FloatingFormItem>
      </Col>

      <Col span={12} md={6}>
        <FloatingFormItem
          parentFieldName="items"
          name={[index, 'quantity']}
          label="Quantidade"
          rules={[ruleRequired]}
        >
          <InputNumber min={1} style={{ width: '100%' }} />
        </FloatingFormItem>
      </Col>

      <Col span={12} md={6}>
        <FloatingFormItem
          parentFieldName="items"
          name={[index, 'unitValue']}
          label="Valor unitário"
          rules={[ruleRequired]}
        >
          <InputDecimal min={0} />
        </FloatingFormItem>
      </Col>

      <Col span={12} md={6}>
        <FloatingFormItem
          parentFieldName="items"
          name={[index, 'discount']}
          label="Desconto"
        >
          <InputDecimal min={0} />
        </FloatingFormItem>
      </Col>

      <Col span={12} md={6}>
        <FloatingFormItem
          parentFieldName="items"
          name={[index, 'expenses']}
          label="Despesa"
        >
          <InputDecimal min={0} />
        </FloatingFormItem>
      </Col>

      <Col span={12} md={6}>
        <FloatingFormItem
          parentFieldName="items"
          name={[index, 'calculationRule']}
          label="Regra de cálculo"
        >
          <Input />
        </FloatingFormItem>
      </Col>

      <Col span={24}>
        <Typography.Title level={5}>Combustível</Typography.Title>
        <Row gutter={16}>
          <Col span={24} md={6}>
            <FloatingFormItem
              parentFieldName="items"
              name={[index, 'fuel', 'anpCode']}
              label="Cód. ANP"
            >
              <Input />
            </FloatingFormItem>
          </Col>

          <Col span={24} md={6}>
            <FloatingFormItem
              parentFieldName="items"
              name={[index, 'fuel', 'simpCode']}
              label="Cód. SIMP"
            >
              <Input />
            </FloatingFormItem>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default InvoiceCFEGeneralForm;
